// extracted by mini-css-extract-plugin
export default {"tab":"tab--rWvejpn6nW","selected":"selected--syqy7rGSiD","hidden":"hidden--g+9vlGHUBA","inline":"inline--RUXsRQRjRM","badges":"badges---IFZroBxKO"};